import React, { useEffect, useState, useMemo } from "react";
import ReactSpeedometer from "react-d3-speedometer";
import {
  List,
  ListItem,
  ListItemText,
  TextField,
  Grid,
  Dialog,
  Box,
  Alert,
  Select,
  Checkbox,
  Stack,
  InputLabel,
  Typography,
  Button,
  MenuItem,
  FormControl,
  AlertTitle,
  FormControlLabel,
  ListItemIcon,
  DialogContent,
  Tooltip,
  Divider,
} from "@mui/material";
import moment from "moment"; // con esto manejamos las fechas bien
import { v4 as uuidv4 } from "uuid"; ///me da un unico id para poner en los pedidos y repartos
import { UrlApi } from "../../../../services/apirest";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import ModalVencimientos from "./ModalVencimientos";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import Notify from "../../../Notify";
import { grey } from "@mui/material/colors";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { getData, postData, putData } from "../../../../services/library";
import { MRT_TablePagination } from "material-react-table";
import { logEventos } from "../../../../services/services";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import EditIcon from "@mui/icons-material/Edit";
import ModalEditar from "./ModalEditar";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import MapaDomPedido from "../../../referencias-tablas/clientes/pedidos/altapedido/Mapas/MapaDomPedido";
import PersonPinCircleIcon from "@mui/icons-material/PersonPinCircle";
import ModalObservacionesInternas from "../../../referencias-tablas/pedidos/ModalObservacionesInternas";
import DialogObservacionesPedido from "./DialogObservacionesPedido"
import DialogObservacionesCC from "./DialogObservacionesCC"
import DialogObservacionesInternas from "./DialogObservacionesInternas";
import ModalEditar2 from "./ModalEditar2";

export default function CrearRepartos2(props) {
  const [fechaseleccionada, setFechaSeleccionada] = useState("");
  const [textotitulo, setTextoTitulo] = useState("");
  const [repartoexiste, setRepartoExiste] = useState(false);
  const [modalVencimientos, setmodalVencimientos] = useState(false);
  const [todoOk, setTodoOk] = useState(false);
  const [reparto_uuid, setRepartotUuid] = useState(uuidv4());
  const [pedidos, setPedidos] = useState([]);
  const [repartos, setRepartos] = useState([]);
  const [vehiculo, setVehiculo] = useState();
  const [deSucursal, setDeSucursal] = useState();
  const [vehiculoSeleccionado, setVehiculoSeleccionado] = useState(null);
  const globalTheme = useTheme();
  const [rowSelection, setRowSelection] = useState({});
  const [datos, setDatos] = useState({})
  const [modalEdit, setmodalEdit] = useState(false);
  const [totalkilos, setTotalkilo] = useState(0);
  const [capacidad, setCapacidad] = useState();
  const [datosSeleccionados, setDatosSeleccionados] = useState(null);
  const [openMapa, setOpenMapa] = useState(false);
  const [requerido, setRequerido] = useState([])
  const iconRemove = <RemoveCircleOutlineIcon sx={{ fontSize: 40 }} />;
  let usuario = localStorage.getItem("user");
  let fecha = moment(new Date()).format("YYYY-MM-DD");
  let vtvOk = vehiculoSeleccionado && vehiculoSeleccionado.vencimiento_vtv_1 > fecha ? true : false;
  let hidraulicaOk = vehiculoSeleccionado && vehiculoSeleccionado.vencimiento_ph_7 > fecha ? true : false;

  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });

  const obtenerPedidos = () => {
    getData("/pedidos/pend_aprobados/sucursales/" + props.sucursal[0].id_sucursal, setPedidos);
  };

  const obtenerVehiculos = () => {
    fetch(UrlApi + "/vehiculos/granelsucursal/" + props.sucursal[0].id_sucursal)
      .then((data) => data.json())
      .then((data) => setVehiculo(data));
  };

  const handleUbicacion = (linea) => {
    setOpenMapa(true);
    setDatos(linea);
  };

  const obtenerAllVehiculos = () => {
    getData("/vehiculos/granel", setVehiculo);
  };

  useEffect(() => {
    obtenerPedidos();
    obtenerVehiculos();
    getData(
      `/pedidos/kgsolicitados/${props.sucursal[0].id_sucursal}`,
      setRequerido
    );
  }, []);

  const handleClose = () => {
    props.setOpen(false);
    props.setMostrarSucursales(true);
    props.actualizar();
  };

  //Cuando cambiamos la fecha para la salida, necesitamos saber si no hay un reparto
  //asignado para ese dia
  useEffect(() => {
    const obtenerRepartos = async () => {
      await fetch(
        UrlApi +
        "/repartos/sucursalfecha/" +
        fechaseleccionada +
        "/" +
        props.sucursal[0].id_sucursal +
        "/" +
        vehiculoSeleccionado.id
      )
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            console.log("Error obteniendo datos");
          }
        })
        .then((data) => {
          data && setRepartos(data);
          data && setRepartoExiste(Object.keys(data).length > 0 ? true : false);
        });
    };
    fechaseleccionada && vehiculoSeleccionado && obtenerRepartos();
  }, [fechaseleccionada, vehiculoSeleccionado, setFechaSeleccionada]);

  useEffect(() => {
    totalkilos === 0
      ? setTextoTitulo("Pedidos sin asignar (Seleccionar al menos uno)")
      : setTextoTitulo("Pedidos sin asignar");
    fechaseleccionada &&
      totalkilos > 0 &&
      vtvOk &&
      hidraulicaOk &&
      !repartoexiste
      ? setTodoOk(true)
      : setTodoOk(false);
  }, [
    datosSeleccionados,
    fechaseleccionada,
    repartoexiste,
    vehiculoSeleccionado,
  ]);

  useEffect(() => {
    if (fecha &&
      (vehiculoSeleccionado && vehiculoSeleccionado.vencimientovtv && vehiculoSeleccionado.vencimientohidraulica && !vehiculoSeleccionado.capacidad)) {
      if (!vtvOk || !hidraulicaOk || !vehiculoSeleccionado.capacidad) {
        setmodalVencimientos(true)

      }
      else {
        setmodalVencimientos(false)
      }
    }
  }, [fecha, vehiculoSeleccionado, vtvOk, hidraulicaOk, setVehiculoSeleccionado,]);

  /// aca grabamos el reparto, si existia un reparto para la fecha seleccionada solo modificamos los pedidos
  const handleSaveDelivery = (e) => [
    e.preventDefault(),
    !repartoexiste
      ? (repartonuevo(e), ponernumerodereparto(e))
      : ponernumerodereparto(e),
    handleClose(),
  ];

  async function repartonuevo(e) {
    postData(
      e,
      "/repartos",
      {
        id_sucursal: props.sucursal[0].id_sucursal,
        id_vehiculo: vehiculoSeleccionado.id,
        usuario: usuario,
        nro_reparto: reparto_uuid,
        estado: 6,
        fecha_salida_reparto: fechaseleccionada,
      },
      setNotificacion,
      props.actualizar(),
      logEventos(
        "Crear rendicion/reparto",
        "Repartos",
        "Repartos",
        localStorage.getItem("user")
      )
    );
  }

  useEffect(() => {
    const { datosSeleccionados, totalkilos } = Object.keys(rowSelection).reduce(
      (result, key) => {
        if (rowSelection[key]) {
          result.datosSeleccionados.push({
            id: pedidos[key].idpedido,
            id_estado: 23,
            nro_reparto: reparto_uuid,
          });
          result.totalkilos += pedidos[key].kgacargar;
        }
        return result;
      },
      { datosSeleccionados: [], totalkilos: 0 }
    );
    setDatosSeleccionados(datosSeleccionados);
    setTotalkilo(totalkilos);
  }, [rowSelection, totalkilos, reparto_uuid]);

  async function ponernumerodereparto(e) {
    await putData(
      e,
      "/pedidos/x/delivery1/updt_obs",
      datosSeleccionados,
      setNotificacion
    );
  }

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  // -------------------parte nueva observaciones --------------------------- //

  //Esto está todo aca porque tengo que mostrar en el tooltip las ultimas observaciones.
  const [openObsAdminChofer, setOpenObsAdminChofer] = useState(false);
  const [openObsCC, setOpenObsCC] = useState(false);
  const [openObsInternas, setOpenObsInternas] = useState(false);

  const handleOnClickObsAdminChofer = (pedido) => {
    setDatos(pedido)
    setOpenObsAdminChofer(true);
  }

  const handleOnClickObsCC = (pedido) => {
    setDatos(pedido)
    setOpenObsCC(true);
  }

  const handleOnClickObsInternas = (pedido) => {
    setDatos(pedido)
    setOpenObsInternas(true);
  }

  // -------------------parte nueva observaciones --------------------------- //


//   const customSortingFn = (rowA, rowB, columnId) => {
//     console.log("rowA", rowA);
//     console.log("rowB", rowB);
    
    
//   const estadoA = rowA.original.id_estado;
//   const estadoB = rowB.original.id_estado;

//   // REGLA DE ORO: Si uno es 19 y el otro no, el 19 SIEMPRE va abajo (es "mayor")
//   if (estadoA === 19 && estadoB !== 19) return 1;
//   if (estadoA !== 19 && estadoB === 19) return -1;

//   // Si ambos son 19 o ambos son 21, comparamos el contenido real de la columna
//   // Usamos rowA.original[columnId] si el accessorKey coincide, 
//   // pero lo más seguro en MRT es usar getValue:
//   let valA = rowA.getValue(columnId);
//   let valB = rowB.getValue(columnId);

//   // Limpieza de nulos para que no rompa el localeCompare
//   valA = valA === null || valA === undefined ? "" : valA;
//   valB = valB === null || valB === undefined ? "" : valB;

//   // Si son números (como en la columna Orden o Requerido)
//   if (!isNaN(valA) && !isNaN(valB) && valA !== "" && valB !== "") {
//     return Number(valA) - Number(valB);
//   }

//   // Si son strings (como Cliente o Localidad)
//   return String(valA).localeCompare(String(valB));
// };

  const columns = useMemo(
    () => [
      {
        header: "Cliente",
       id: "razon_social",
        accessorFn: (c) =>
          `${c.IDsisven ?? ""} - ${c.razon_social} (${c.empresa})`,
        enableEditing: false,
        //sortingFn: customSortingFn,
      },
      {
        header: "Localidad",
        id:"id_localidad",
        accessorKey: "localidad_direccion",
        enableEditing: false,
        size: 70,
        // //sortingFn: customSortingFn,
      },
      {
        header: "Dir.Entrega",
        id: "direccion",
        accessorFn: (c) => `${c.direccion_entrega} (${c.nombre_direccion})`,
        enableEditing: false,
        //sortingFn: customSortingFn,

      },
      {
        header: "Obs",
        accessorKey:"obs_chofer",
        //sortingFn: customSortingFn,
        accessorFn: (o) => o.obs_chofer ?? o.observaciones,
        enableEditing: false,
        size: 45,
        Cell: ({ cell, row }) => {
          return (
            <div
              style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
            >
              <Tooltip
                title={"Observaciones chofer/logística"}
              >
                <FindInPageIcon
                  onClick={() => {
                    handleOnClickObsAdminChofer(row.original)
                  }}
                  style={{ color: "green" }}
                  size="small"
                />
              </Tooltip>

              {
                row?.original?.obs_cc_count > 0 && (
                  <>

                    <Tooltip
                      title={"Observaciones CUENTAS CORRIENTES"}
                    >
                      <FindInPageIcon
                        onClick={() => {
                          handleOnClickObsCC(row.original)
                        }}
                        style={{ color: "orange" }}
                        size="small"
                      />
                    </Tooltip>

                  </>
                )
              }
              <Tooltip
                title={"Observaciones INTERNAS"}
              >
                <FindInPageIcon
                  onClick={() => {
                    handleOnClickObsInternas(row.original)
                  }}
                  style={{ color: "pink" }}
                  size="small"
                />
              </Tooltip>
            </div>
          );
        },
      },
      {
        header: "Requerido",
        //sortingFn: customSortingFn,
        accessorKey: "kgacargar",
        size: 70,
        enableEditing: false,
      },
      {
        header: "Porcentaje (%)",
        accessorKey: "porcentaje",
        //sortingFn: customSortingFn,
        size: 70,
        enableEditing: false,
      },
      {
        header: "Registrado",
        id: "fecha_registro",
        //sortingFn: customSortingFn,
        accessorFn: (reg) => moment(reg.registrado).format("DD-MM-YYYY"),
        type: "date",
        format: "YYYY-MM-DD",
        enableEditing: false,
        size: 60,
      },
      {
        header: "Orden",
        //sortingFn: customSortingFn,
        accessorKey: "orden_prioridad",
        type: "numeric",
        size: 50,
      },

    ],
    []
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };

  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary, //primary color for the table
          info: {
            main: "rgb(255,122,0)", //add in a custom color for the toolbar alert background stuff
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)"
                : "#000", //pure black table in dark mode for fun
          },
        },
        typography: {
          button: {
            textTransform: "none", //customize typography styles for all buttons in table by default
            fontSize: "1.2rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "1.1rem", //larger tooltip font size
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 50 },
  };

  const editRow = (e) => {
    setmodalEdit(true);
    setDatos(e);
  };

  return (
    <div>
      {pedidos && (
        <>
          <Grid container spacing={2}>
            <Grid item xs={4} sx={{ width: 100, height: 210 }}>
              {!vehiculoSeleccionado ? ( // Verificar si no hay un vehículo seleccionado
                <Grid
                  p={2}
                  mt={2}
                  container
                  backgroundColor={grey[100]}
                  border={1}
                  borderColor={"steelblue"}
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Grid item xs={12}>
                    <AccessTimeIcon />
                    <Typography>
                      Seleccione un vehículo para empezar la rendición
                    </Typography>
                  </Grid>
                </Grid>
              ) : (
                <ReactSpeedometer
                  minValue={0} // Valor mínimo
                  maxValue={capacidad} // Valor máximo basado en la capacidad del vehículo
                  value={totalkilos} // Asegúrate de que este valor esté dentro del rango entre 0 y maxValue
                  currentValueText={"${value} Kgs"}
                  needleColor="steelblue"
                  needleTransitionDuration={4000}
                  needleTransition="easeElastic"
                  forceRender={true}
                  customSegmentStops={[
                    0, // Valor mínimo
                    (capacidad * 0.75).toFixed(0),
                    (capacidad * 0.85).toFixed(0),
                    capacidad, // El último valor debe ser igual a maxValue
                  ]}
                  segmentColors={["lightgreen", "orange", "red"]}
                  startColor="green"
                  endColor="red"
                />
              )}
            </Grid>
            <Grid item xs={12} md>
              <Grid item xs container direction="column" spacing={2}>
                <Grid item>
                  <Grid
                    container
                    spacing={1}
                    direction={{ xs: "column", sm: "row" }}
                    mt={0.5}
                    mb={1}
                  >
                    <Grid item xs={9}>
                      <FormControl fullWidth focused size="small">
                        <InputLabel>Vehiculo</InputLabel>
                        <Select
                          label="Vehiculo"
                          value={vehiculoSeleccionado}
                          onChange={(e) => {
                            setVehiculoSeleccionado(e.target.value);
                            setCapacidad(
                              e.target.value.capacidad !== null
                                ? e.target.value.capacidad
                                : 10000
                            );
                          }}
                          sx={{
                            "& .MuiInputBase-input.Mui-disabled": {
                              WebkitTextFillColor: "teal",
                            },
                          }}
                          InputLabelProps={{ style: { color: "black" } }}
                          inputProps={{
                            min: 0,
                            style: {
                              textAlign: "center",
                              fontSize: 25,
                              fontFamily: '"Comic Sans MS"',
                              width: 300,
                              padding: 0,
                            },
                          }}
                        >
                          {vehiculo
                            ? vehiculo.map((elemento) => (
                              <MenuItem key={elemento.id} value={elemento}>
                                {elemento.nombrepila && elemento.apellido
                                  ? `${elemento.patente} (${elemento.nombrepila} ${elemento.apellido})`
                                  : `${elemento.patente}`}
                              </MenuItem>
                            ))
                            : null}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={3}>
                      <FormControlLabel
                        checked={deSucursal}
                        onChange={(e) => {
                          setDeSucursal(e.target.checked);
                          e.target.checked
                            ? obtenerAllVehiculos()
                            : obtenerVehiculos();
                        }}
                        control={<Checkbox />}
                        label="Otra Sucursal"
                        sx={{ "& .MuiSvgIcon-root": { fontSize: 20 } }}
                      />
                    </Grid>

                    <Grid container mt={1} ml={1}>
                      {vehiculoSeleccionado ?
                        <>
                          <TextField
                            label="Vto VTV"
                            variant='outlined'
                            value={vehiculoSeleccionado && vehiculoSeleccionado.vencimiento_vtv_1 ? moment(vehiculoSeleccionado.vencimiento_vtv_1).format("DD-MM-YYYY") : "Sin registrar"} disabled={true}
                            sx={{ "& .MuiInputBase-input.Mui-disabled": { WebkitTextFillColor: vtvOk ? "black" : "black", }, }}
                            InputLabelProps={{ style: { color: 'black' }, }}
                            inputProps={{ min: 0, style: { textAlign: 'center', backgroundColor: vtvOk ? "#afdbaf" : " #de8787", width: 290, padding: 6, } }}
                          />
                          <TextField
                            label="Vto PH"
                            variant='outlined'
                            value={vehiculoSeleccionado && vehiculoSeleccionado.vencimiento_ph_7 ? moment(vehiculoSeleccionado.vencimiento_ph_7).format("DD-MM-YYYY") : "Sin registrar"} disabled={true}
                            sx={{ "& .MuiInputBase-input.Mui-disabled": { WebkitTextFillColor: hidraulicaOk ? "black" : "black", }, }}
                            InputLabelProps={{ style: { color: 'black' }, }}
                            inputProps={{ min: 0, style: { textAlign: 'center', backgroundColor: hidraulicaOk ? "#afdbaf" : " #de8787", width: 290, padding: 6, marginLeft: 6 } }}
                          />
                        </>
                        :
                        <>
                          <TextField
                            label="Vto VTV"
                            variant='outlined'
                            value={moment(fecha).format("DD-MM-YYYY")} disabled={true}
                            sx={{ "& .MuiInputBase-input.Mui-disabled": { WebkitTextFillColor: vtvOk ? "black" : "black", }, }}
                            InputLabelProps={{ style: { color: 'black' }, }}
                            inputProps={{ min: 0, style: { textAlign: 'center', backgroundColor: "#afdbaf", width: 290, padding: 6, } }}
                          />
                          <TextField
                            label="Vto PH"
                            variant='outlined'
                            value={moment(fecha).format("DD-MM-YYYY")} disabled={true}
                            sx={{ "& .MuiInputBase-input.Mui-disabled": { WebkitTextFillColor: hidraulicaOk ? "black" : "black", }, }}
                            InputLabelProps={{ style: { color: 'black' }, }}
                            inputProps={{ min: 0, style: { textAlign: 'center', backgroundColor: "#afdbaf", width: 290, padding: 6, marginLeft: 6 } }}
                          /></>}
                    </Grid>
                  </Grid>
                  <TextField
                    required
                    label="Fecha de salida"
                    variant='outlined'
                    size='small'
                    borderColor='white'
                    name="fecha_salida_reparto"
                    value={moment(fechaseleccionada).format("YYYY-MM-DD")}
                    onChange={(e) => setFechaSeleccionada(e.target.value)}
                    fullWidth
                    type="date"
                    inputProps={{
                      min: moment(new Date()).format("YYYY-MM-DD")
                    }}
                  />
                </Grid>
                <Grid container mt={0.5} xs={12} md >
                  {Object.keys(repartos).length > 0 ?
                    <Stack sx={{ width: '145%' }} spacing={2}>
                      <Alert severity='info'>
                        Ya existe una rendición para esa fecha Número <strong>{repartos[0].idreparto}</strong>
                        <br />
                        Capacidad libre en vehiculo:<strong>{repartos[0].capacidad - repartos[0].kgacargar}</strong>
                        <AlertTitle>
                          Por favor elija otro vehiculo u otra fecha
                        </AlertTitle>
                      </Alert>
                    </Stack>
                    : null}
                </Grid>
              </Grid>
            </Grid>

            <Grid item flex={0} container direction="column">
              <Grid item xs={4}>
                <Button
                  disabled={!todoOk}
                  onClick={handleSaveDelivery}
                  variant="outlined"
                  color="success"
                >
                  Confirmar
                </Button>
              </Grid>
              <Grid item xs={4}>
                <Button
                  onClick={handleClose}
                  variant="outlined"
                  color="error"
                  fullWidth
                >
                  Volver
                </Button>
              </Grid>
            </Grid>
          </Grid>

          <Box mt={2} boxShadow={3} mb={5}>
            <ThemeProvider theme={tableTheme}>
              <MaterialReactTable
                state={{ rowSelection }}
                positionActionsColumn="last"
                enableColumnResizing
                columns={columns}
                enableSorting={true}
                enableColumnFilters={false}
                data={pedidos}
                initialState={initialState}
                // state={{ rowSelection }}
                muiTableHeadCellProps={tableHeadCellProps}
                enableToolbarInternalActions={true}
                enableRowSelection={(row) => row?.original?.id_estado == 21}
                enableRowActions
                enableBottomToolbar={true}
                onRowSelectionChange={setRowSelection}
                muiTableBodyCellProps={({ row }) => ({
                  align: "left",
                  sx: {
                    backgroundColor:
                      (row.original.id_estado == 19 && "#ebebeb") ||
                      (row.original.porcentaje < 20 &&
                        row.original.porcentaje !== null
                        ? "#f58c8c"
                        : "#fff"),
                    color: row.original.id_estado == 19 && "#666464e5",
                    borderColor: "black",
                  },
                })}
                renderTopToolbarCustomActions={() => (
                  <>
                    <Typography variant="poster" fontSize={20}>
                      {textotitulo}
                    </Typography>
                  </>
                )}
                enableExpandAll={false}
                enableColumnActions={false}
                muiSearchTextFieldProps={muiSearchTextFieldProps}
                enableDensityToggle={false}
                layoutMode="semantic"
                displayColumnDefOptions={{
                  "mrt-row-select": {
                    size: 1,
                  },
                }}
                localization={MRT_Localization_ES}
                enableColumnDragging={false}
                enableHiding={false}
                positionExpandColumn="first"
                renderRowActionMenuItems={({ closeMenu, row }) => [
                  <MenuItem
                    key={1}
                    onClick={() => {
                      closeMenu();
                      editRow(row.original);
                    }}
                    sx={{ m: 0 }}
                    disabled={row.original.id_estado === 19}
                  >
                    <ListItemIcon>
                      <EditIcon color="primary" />
                    </ListItemIcon>
                    Editar
                  </MenuItem>,
                  <MenuItem
                    key={1}
                    onClick={() => {
                      closeMenu();
                      handleUbicacion(row.original);
                    }}
                    sx={{ m: 0 }}
                    disabled={row.original.id_estado == 19}
                  >
                    <ListItemIcon>
                      <PersonPinCircleIcon color="warning" />
                    </ListItemIcon>
                    Ver ubicación
                  </MenuItem>,
                ]}
                // enableBottomToolbar={true}
                //  enableStickyFooter
                renderBottomToolbar={({ table }) => (
                  <Box>
                    <Box
                      display="flex"
                      justifyContent="end"
                      alignItems="center"
                      padding={1}
                    >
                      <Typography variant="poster" fontSize={20} color="red">
                        TOTAL: {requerido[0]?.requerido}
                      </Typography>

                      <MRT_TablePagination table={table} />
                    </Box>
                  </Box>
                )}
              />
            </ThemeProvider>
          </Box>
        </>
      )}

      {openObsAdminChofer && (
        <DialogObservacionesPedido
          open={openObsAdminChofer}
          setOpen={setOpenObsAdminChofer}
          pedido={datos} //esto deberia pasarlo como "pedido"
          handleClose={() => setOpenObsAdminChofer(false)}
        />
      )}

      {openObsCC && (
        <DialogObservacionesCC
          open={openObsCC}
          setOpen={setOpenObsCC}
          handleClose={() => setOpenObsCC(false)}
          pedido={datos}
        />
      )}

      {openObsInternas && (
        <DialogObservacionesInternas
          open={openObsInternas}
          setOpen={setOpenObsInternas}
          pedido={datos}
          handleClose={() => setOpenObsInternas(false)}
        />
      )}

      {modalVencimientos ? (
        <ModalVencimientos
          open={setmodalVencimientos}
          vtv={vtvOk}
          hidraulica={hidraulicaOk}
          capacidad={vehiculoSeleccionado?.capacidad}
        />
      ) : null}

      {notificacion && notificacion.open ? (
        <Notify
          mensaje={notificacion.mensaje}
          open={notificacion.open}
          color={notificacion.color}
          handleClose={handleClose}
          severity={notificacion.severity}
        />
      ) : null}

      {modalEdit ? (
        <ModalEditar2
          open={modalEdit}
          datos={datos}
          setOpen={setmodalEdit}
          actualizar={obtenerPedidos}
          getPedidos={obtenerPedidos}
          refreshRepartos={props.actualizar}
        />
      ) : null}

      {openMapa ? (
        <Dialog open={openMapa} onClose={() => setOpenMapa(false)}>
          <DialogContent>
            <MapaDomPedido
              idDireccion={datos.iddireccion_entrega}
              handleClose={() => setOpenMapa(false)}
            ></MapaDomPedido>
          </DialogContent>
        </Dialog>
      ) : null}
    </div>
  );
}
